<mat-card >
        <!-- Favourites -->
        <div class="panel__header__buttons flex-container row" style="float: right;">
            <div *ngFor="let favorite of userFavorites"   class="favourites flex-item">
                <a class="button button--hover-icon" style="background-color: deepskyblue"
                    >
                    <span class="button__text" style="color: white" 
                    (click)="showFavorite(favorite)" >{{favorite.Name}}</span>
                    <i class="material-icons button__icon" style="color: white" matTooltip="{{'Edit Favourite' | translate | async}}"
                [matMenuTriggerFor]="menu2">more_vert</i>
                </a>
                <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="UpdateFavourite(favorite)" style="cursor: pointer;">
                        <mat-icon>edit</mat-icon>
                        <span>{{'Update Favourite' | translate | async}}</span>
                    </button>
                    <button mat-menu-item (click)="deleteFavorite(favorite)">
                        <mat-icon>delete_forever</mat-icon>
                        <span>{{'Delete' | translate | async}}</span>
                    </button>
                </mat-menu>
            </div>

            <div class="fav-divider"></div>
            <a class="button" (click)="OpenFavourite()" >
                <i class="material-icons button__icon">favorite</i>
                <span class="button__text">{{'Create Favourite' | translate | async}}</span>
            </a>
            <div class="icon" style="cursor: pointer;" (click)="showAlertDialog()" *ngIf="EnableDashboardAlerts" >
                <mat-icon >notifications_none</mat-icon>
                <div  class="txt"  *ngIf="showText" style="cursor: pointer;" >{{numberofNotifications}}</div>
            </div>  
        </div>

<!-- Favourites -->

    <div class="search-options"  style="width: 100%;">


        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Form Category</span>
              <mat-select id="select-category" placeholder="Select Form Category" [(ngModel)]="selectedCategory"
                  (selectionChange)="LoadForms()" ngDefaultControl  multiple>
                  <mat-option [value]="cat.Id" *ngFor="let cat of formCatList">
                      {{cat.Name}}
                  </mat-option>
              </mat-select>
        </mat-form-field> -->
       <!-- 1 -->
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Form Category' | translate | async}}</span>
            <mat-chip-list #categoryChipList>
              <mat-chip *ngFor="let category of selectedCategories" [selectable]="true" [removable]="true" (removed)="removeCategory(category)">
                {{ category.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                placeholder="{{'Select Form Category' | translate | async}}"
                #categoryInput
                [matAutocomplete]="autoCategory"
                [matChipInputFor]="categoryChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addCategory($event)"
                (input)="filterCategories($event.target.value)"
              />
            </mat-chip-list>
            <mat-autocomplete #autoCategory="matAutocomplete" (optionSelected)="selectCategory($event)">
              <mat-option *ngFor="let category of filteredCategories" [value]="category">
                {{ category.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- 2 -->
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Customer' | translate | async}}</span>
            <mat-chip-list #chipList>
              <!-- Display selected customers as chips -->
              <mat-chip *ngFor="let chip of selectedCustomers" [selectable]="true" [removable]="true" (removed)="removeChip(chip)">
                {{ chip.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
          
              <!-- Input field for autocomplete -->
              <input 
                placeholder="{{'Select Customer' | translate | async}}" 
                #chipInput 
                [matAutocomplete]="auto" 
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                (input)="filterCustomers($event.target.value)" 
                [matChipInputAddOnBlur]="true"
                name="customer" 
                ngDefaultControl />
            </mat-chip-list>
          
            <!-- Autocomplete dropdown -->
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCustomer($event)">
              <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.Name">
                {{ customer.Name }}
              </mat-option>
            </mat-autocomplete>
        </mat-form-field>
          
   
          
<!-- 
        <mat-form-field class="header-form-full-width">
            <span class="label">Family</span>
            <mat-select id="select-type" placeholder="Select Family" [(ngModel)]="selectedFamily" (selectionChange)="loadModelList()"
                    ngDefaultControl  multiple>
                    <mat-option [value]="type.Id" *ngFor="let type of  familyList">
                        {{type.Name}}
                    </mat-option>
                </mat-select>
        </mat-form-field> -->
       
          
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Family</span>
            <mat-chip-list #FamilychipList>
              <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true"
                (removed)="removeFamily(family)">
                {{ family }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
        
              <input placeholder="Select Family" #familyInput [matAutocomplete]="autoFamily" [matChipInputFor]="FamilychipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addFamily($event)"  [matChipInputAddOnBlur]="true"
                (input)="filterFamilies($event.target.value)" />
            </mat-chip-list>
            <mat-autocomplete   [(ngModel)]="selectFamily" #autoFamily="matAutocomplete"
              (optionSelected)="selectFamily($event.option)">
              <mat-option [value]="family.Name" *ngFor="let family of filteredFamilies ">
                {{ family.Name }}
              </mat-option>
            </mat-autocomplete>
            <mat-autocomplete #autoFamily="matAutocomplete">
                <mat-option *ngFor="let family of filteredFamilies" [value]="family">
                  {{ family.Name }}
                </mat-option>
              </mat-autocomplete>

          </mat-form-field> -->
          <!-- 3 -->
          <mat-form-field class="header-form-full-width">
            <span class="label">{{'Family' | translate | async}}</span>
            <mat-chip-list #FamilychipList>
              <!-- Display selected families as chips -->
              <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true" (removed)="removeFamily(family)">
                {{ family.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
          
              <!-- Input field for autocomplete -->
              <input 
                placeholder="{{'Select Family' | translate | async}}" 
                #familychipInput 
                [matAutocomplete]="autoFamily" 
                [matChipInputFor]="FamilychipList" 
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                (input)="filterFamilies($event.target.value)" 
                name="family" 
                ngDefaultControl />
            </mat-chip-list>
          
            <!-- Autocomplete dropdown -->
            <mat-autocomplete #autoFamily="matAutocomplete" (optionSelected)="selectFamily($event)">
              <mat-option *ngFor="let family of filteredFamilies" [value]="family.Name">
                {{ family.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Machine</span>
            <mat-select id="select-equipment-serialno" placeholder="Select Machine"
            [(ngModel)]="selectedEquipment" ngDefaultControl   multiple>
            <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                   {{equipment.UnitNumber}}||{{equipment.SerialNumber}}
            </mat-option>
        </mat-select>
        </mat-form-field> -->
        <!-- 4 -->
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Machine' | translate | async}}</span>
            <mat-chip-list #equipmentChipList aria-label="Machine selection">
                <mat-chip
                  *ngFor="let equipment of selectedEquipment"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeEquipment(equipment)">
                  {{ equipment.UnitNumber }} || {{ equipment.SerialNumber }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input
                  placeholder="{{'Select Machine' | translate | async}}"
                  #equipmentInput
                  [matAutocomplete]="autoEquipment"
                  [matChipInputFor]="equipmentChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (input)="filterEquipment($event.target.value)" />
              </mat-chip-list>
              
              <mat-autocomplete #autoEquipment="matAutocomplete" (optionSelected)="selectEquipment($event)">
                <mat-option *ngFor="let equipment of filteredEquipment" [value]="equipment">
                  {{ equipment.UnitNumber }} || {{ equipment.SerialNumber }}
                </mat-option>
              </mat-autocomplete>
              
          </mat-form-field>

          <!-- 5 -->
          <mat-form-field class="header-form-full-width">
            <span class="label">{{'Form Name' | translate | async}}</span>
            <mat-chip-list #formChipList>
              <mat-chip *ngFor="let form of selectedForms" [selectable]="true" [removable]="true" (removed)="removeForm(form)">
                {{ form.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                placeholder="{{'Select Form Name' | translate | async}}"
                #formInput
                [matAutocomplete]="autoForm"
                [matChipInputFor]="formChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addForm($event)"
                (input)="filterForms($event.target.value)"
              />
            </mat-chip-list>
            <mat-autocomplete #autoForm="matAutocomplete" (optionSelected)="selectForm($event)">
              <mat-option *ngFor="let form of filteredForms" [value]="form">
                {{ form.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- 6 -->
          <mat-form-field class="header-form-full-width">
            <span class="label">{{'Job Site' | translate | async}}</span>
            <mat-chip-list #jobsiteChipList>
              <mat-chip *ngFor="let jobsite of selectedJobsites" [selectable]="true" [removable]="true"
                (removed)="removeJobsite(jobsite)">
                {{ jobsite.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input placeholder="{{'Select Job Site' | translate | async}}" #jobsiteInput [matAutocomplete]="autoJobsite"
                [matChipInputFor]="jobsiteChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addJobsite($event)"
                (input)="filterJobsites($event.target.value)" />
            </mat-chip-list>
            <mat-autocomplete #autoJobsite="matAutocomplete" (optionSelected)="selectJobsite($event)">
              <mat-option *ngFor="let jobsite of filteredJobsites" [value]="jobsite">
                {{ jobsite.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
    
          
          
          

         <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Inspector</span>
            <mat-select id="select-inspector" placeholder="Select Inspector" [(ngModel)]="selectedInspectors"
                ngDefaultControl  multiple>
                <mat-option [value]="inspector.Id" *ngFor="let inspector of inspectorList">
                    {{inspector.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>  -->
      
          


        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Customer</span>
            <mat-select id="select-customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer"
                    (selectionChange)="loadJobsitesForCustomer();loadFamiliesForCustomer()" ngDefaultControl  multiple>
                    <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                        {{customer.Name}}
                    </mat-option>
                </mat-select>
        </mat-form-field> -->
        

        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Customer</span>
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let chip of selectedCustomers" [selectable]="true" [removable]="true"
                (removed)="removeChip(chip)">
                {{ chip }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
        
              <input placeholder="Select Customer" #chipInput [matAutocomplete]="auto" [matChipInputFor]="chipList"   [matChipInputAddOnBlur]="true"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addCustomer($event)"
                (input)="filterCustomers($event.target.value)" />
            </mat-chip-list>
            <mat-autocomplete  [(ngModel)]="selectCustomer" #auto="matAutocomplete"
              (optionSelected)="onSelectCustomer($event.option)">
              <mat-option [value]="customer.Name" *ngFor="let customer of filteredCustomers ">
                {{ customer.Name }}
              </mat-option>
            </mat-autocomplete>
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let customer of filteredCustomers" [value]="customer">
                  {{ customer.Name }}
                </mat-option>
              </mat-autocomplete>
          </mat-form-field> -->

        

        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Model</span>
            <mat-select id="select-model" placeholder="Select Model" [(ngModel)]="selectedModel" ngDefaultControl
             multiple>
            <mat-option [value]="model.Id" *ngFor="let model of modelList">
                {{model.Name}}
            </mat-option>
        </mat-select>
        </mat-form-field> -->
        <!-- 7 -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Model' | translate | async}}</span>
          <mat-chip-list #modelChipList>
            <mat-chip
              *ngFor="let model of selectedModels"
              [selectable]="true"
              [removable]="true"
              (removed)="removeModel(model)"
            >
              {{ model.Name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="{{'Select Model' | translate | async}}"
              #modelInput
              [matAutocomplete]="autoModel"
              [matChipInputFor]="modelChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              (matChipInputTokenEnd)="addModel($event)"
              (input)="filterModels($event.target.value)"
            />
          </mat-chip-list>
          <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="selectModel($event)">
            <mat-option *ngFor="let model of filteredModelList" [value]="model">
              {{ model.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
          <!-- 8 -->
            <mat-form-field class="header-form-full-width">
            <span class="label">{{'Inspector' | translate | async}}</span>
            <mat-chip-list #inspectorChipList>
              <mat-chip *ngFor="let inspector of selectedInspectors"
                        [selectable]="true"
                        [removable]="true"
                        (removed)="removeInspector(inspector)">
                {{ inspector.Name  | aesDecrypt}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                placeholder="{{'Select Inspector' | translate | async}}"
                #inspectorInput
                [matAutocomplete]="autoInspector"
                [matChipInputFor]="inspectorChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addInspector($event)"
                (input)="filterInspectors($event.target.value)"
              />
            </mat-chip-list>
            <mat-autocomplete #autoInspector="matAutocomplete" (optionSelected)="selectInspector($event)">
              <mat-option *ngFor="let inspector of filteredInspectors" [value]="inspector">
                {{ inspector.Name | aesDecrypt}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          
    
          

        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Form Name</span>
            <mat-select id="select-forms" placeholder="Select Form Name" [(ngModel)]="selectedForms"
                ngDefaultControl  multiple>
                <mat-option [value]="form.Id" *ngFor="let form of formList">
                    {{form.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>  -->
        
          
          
       
       
   

        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Status</span>
                <mat-select id="select-flag-type" placeholder="Select Status" [(ngModel)]="selectedStatus"
                    ngDefaultControl  multiple>
                    <mat-option [value]="1">Not Started </mat-option>
                    <mat-option [value]="2">In Progress </mat-option>
                    <mat-option [value]="3">In Review </mat-option>
                    <mat-option [value]="4">Completed </mat-option>

                </mat-select>
        </mat-form-field> -->
    
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Jobsite</span>
            <mat-select id="select-jobsite" placeholder="Select Job Site" [(ngModel)]="selectedJobsite"
            (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl  multiple>
            <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                {{jobsite.Name}}
            </mat-option>
        </mat-select>
        </mat-form-field> -->
        
       
    
         <!-- <mat-form-field class="header-form-full-width"></mat-form-field> -->
    
      
        
        <mat-form-field class="header-form-full-width">
            <input matInput [matDatepicker]="startDatePicker" placeholder="Start Date" [(ngModel)]="startDate" style="margin-top: 4%;">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <input matInput [matDatepicker]="endDatePicker" placeholder="End Date" [(ngModel)]="endDate"  style="margin-top: 4%;">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Select Custom Date Range' | translate | async}}</span>
                <mat-select id="select-date-type" placeholder="{{'Select Custom Date Range' | translate | async}}" [(ngModel)]="selectedDateRange"
                (selectionChange)="ChangeCustomeDateType()">
                    <mat-option [value]="range.Id" *ngFor="let range of dateRangetypes">
                        {{range.Name}}
                    </mat-option>

                </mat-select>
        </mat-form-field>
    </div>

   <div style="display: flex; justify-content: space-between;">
        <!-- <div class="search-options-cell-button" style="display: flex;">
            <div class="input-container addsapce" style="   margin-left: -6%;margin-top: -1%;">
                <span class="label" style="    margin-left: 30%;">Show/Hide</span>
            </div>
            <mat-checkbox  class="example-margin" [(ngModel)]="Customer" (change)="changeCheckbox(Customer, 'EqCustomer',2 )">Customer</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Jobsite" (change)="changeCheckbox(Jobsite, 'EQJobsite',3 )"> Jobsite</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="SerialNo"(change)="changeCheckbox(SerialNo, 'Serial',4 )">SerialNo</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="UnitNo" (change)="changeCheckbox(UnitNo, 'Unit',5 )">
                UnitNo</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Family" (change)="changeCheckbox(Family, 'Family',6 )">
                Family</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Model" (change)="changeCheckbox(Model, 'Model' ,7)">Model
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="SMRDiff" (change)="changeCheckbox(SMRDiff, 'SMRDiff' ,9)">SMU Difference
            </mat-checkbox>
        </div> -->
        <!-- STATUS -->
        <div class="search-options-cell-button" style="display: flex;">
            <div class="input-container addsapce" style="   margin-left: -6%;margin-top: -1%;">
                <span class="label" style="margin-left: 30%;">{{'Status' | translate | async}}</span>
            </div>
            <mat-checkbox class="example-margin" [(ngModel)]="NotCompleted" (change)="selectStatus(1, $event)">{{'Not Started' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="inProgress" (change)="selectStatus(2, $event)">{{'In Progress' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="inReview" (change)="selectStatus(3, $event)">{{'In Review' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="inCompleted" (change)="selectStatus(4, $event)">{{'Completed' | translate | async}}</mat-checkbox>
        </div>
    
        <div class="search-options-cell-button" style="display: flex;margin-top: -6px;" *ngIf="flagTypesList.length>0">
            <div >
                <div class="chkbox">
                    <input class="filled-in get-Input-Checkbox" type="checkbox" id="chkAllFlags" [(ngModel)]="AllFlags"  />
                    <label for="chkAllFlags"> All
                    </label>
                </div>
            </div>
            <div >
                <div class="chkbox">
                    <input class="filled-in get-Input-Checkbox" type="checkbox" id="chkAttentionRequired"
                        [(ngModel)]="AttentionRequired" />
                    <label for="chkAttentionRequired">
                        <i class="material-icons button__icon"
                            style="font-size: 35px; vertical-align: middle;margin-top: -13%;"
                            [style.color]="GetColor(1)" title="{{'Attention Required' | translate | async}}">flag</i>
                    </label>
                </div>
            </div>
            <!-- <div >
                <div class="chkbox">
                    <input class="filled-in get-Input-Checkbox" type="checkbox" id="chkImmediateAction" [(ngModel)]="ImmediateAction" />
                    <label for="chkImmediateAction">
                        <i class="material-icons button__icon"
                            style="font-size: 35px; vertical-align: middle;margin-top: -13%;"
                            [style.color]="GetColor(2)" title="{{'Immediate Action required' | translate | async}}">flag</i>
                    </label>
                </div>
            </div> -->
            <div >
                <div class="chkbox">
                    <input class="filled-in get-Input-Checkbox" type="checkbox" id="chkMultipleAnswers" [(ngModel)]="MultipleAnswers" />
                    <label for="chkMultipleAnswers">
                        <i class="material-icons button__icon"
                            style="font-size: 35px; vertical-align: middle;margin-top: -13%;"
                            [style.color]="GetColor(3)" title="{{'Multiple Answers' | translate | async}}">flag</i>
                    </label>
                </div>
            </div>
            <div >
                <div class="chkbox">
                    <input class="filled-in get-Input-Checkbox" type="checkbox" id="chkCommentAdded" [(ngModel)]="CommentAdded" />
                    <label for="chkCommentAdded">
                        <i class="material-icons button__icon"
                            style="font-size: 35px; vertical-align: middle;margin-top: -13%;"
                            [style.color]="GetColor(4)" title="{{'Comment Added' | translate | async}}">flag</i>
                    </label>
                </div>
            </div>
        </div>
        <div class="search-options-cell-button">
            <div style="display: flex;flex-direction: row;justify-content: flex-end; gap:5px;">
                <a class="button" (click)="ResetFields()">
                    <i class="material-icons button__icon">refresh</i>
                    <span class="button__text">{{'Reset' | translate | async}}</span>
                </a>
                <a class="button button--primary" (click)="submitSelection()">
                    <i class="material-icons button__icon">search</i><span class="button__text">{{'Search' | translate | async}}</span>
                </a>
            </div>
        </div>
    </div> 
</mat-card>
<div class="deleteformbutton" *ngIf="selection.hasValue()">
    <a class="button button--primary" (click)="OpenCheckboxDeleteInspection()">
        <span class="button__text">{{'Delete' | translate | async}}</span>
    </a>
</div>

<mat-tab-group class="tbl-padding">
    <mat-tab label="{{'In Progress/Completed' | translate | async}}">
    <!-- <mat-tab label="In Progress/Completed" *ngIf="isSupervisour==true || isInspector==true || isJobRoleDefault==false"> -->
        <div style="margin-left: 39%;" *ngIf="loading">
            <mat-spinner> </mat-spinner>
        </div>
       <i *ngIf="!loading && !showBar" class="material-icons" (click)="ShowHidefield()" style="cursor: pointer; transform: scale(1) rotate(90deg); color: #428bca;">
        forward
       </i>
       <i *ngIf="!loading && showBar" class="material-icons" (click)="ShowHidefield()" style="cursor: pointer; transform: scale(1) rotate(270deg); color: #428bca;">
        forward
       </i>
       <div class="search-options-cell-button" *ngIf="!loading && showBar">
        <div *ngIf="showBar" style="display: flex; flex-direction: row; width: 80%;">
          <!-- <div class="input-container addsapce"> -->
            <span class="label" style="color: black; width: 70px;">{{'Show/Hide' | translate | async}}</span>
          <!-- </div> -->
            <mat-checkbox class="example-margin" [(ngModel)]="Customer" (change)="changeCheckbox(Customer, 'EqCustomer',2 )">{{'Customer' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Jobsite" (change)="changeCheckbox(Jobsite, 'EQJobsite',3 )"> {{'Jobsite' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="SerialNo"(change)="changeCheckbox(SerialNo, 'Serial',4 )"> {{'SerialNo' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="UnitNo" (change)="changeCheckbox(UnitNo, 'Unit',5 )"> {{'UnitNo' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Family" (change)="changeCheckbox(Family, 'Family',6 )"> {{'Family' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Model" (change)="changeCheckbox(Model, 'Model' ,7)"> {{'Model' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="SMRDiff" (change)="changeCheckbox(SMRDiff, 'SMRDiff' ,9)"> {{'SMU Difference' | translate | async}}</mat-checkbox>
       </div>
       </div>

        <div>
        <!-- <div *ngIf="FilledFilteredDigitalForms != null && !loading"> -->
            
            <mat-table class="table-material table-material--striped table-material--hover table-material--full-width" #table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
                <ng-container matColumnDef="FormId">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                            [checked]="selection.isSelected(element)">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="FormName">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Form Name' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.FormName}}">
                        <div class="SerialAndUnitText"> {{element.FormName}} </div>
                    </mat-cell>

                </ng-container>
                <ng-container matColumnDef="CatName">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Form Category' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.CatName}}">
                        <div class="SerialAndUnitText"> {{element.CatName}} </div>
                    </mat-cell>

                </ng-container>
                <ng-container matColumnDef="EqCustomer">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Customer' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.EqCustomer}}">
                        <div class="SerialAndUnitText"> {{element.EqCustomer}} </div>
                    </mat-cell>

                </ng-container>

                <ng-container matColumnDef="EQJobsite">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'JobSite' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.EQJobsite}}">
                        <div class="SerialAndUnitText">{{element.EQJobsite}} </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Serial">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Serial no' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Serial}}">
                        <div class="SerialAndUnitText">{{element.Serial}} </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Unit">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Unit no' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Unit}}">
                        <div class="SerialAndUnitText">{{element.Unit}} </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Family">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Family' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Family}}">
                        <div class="SerialAndUnitText" style="width: 75px;"> {{element.Family}} </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Model">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Model' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Model}}">
                        <div class="SerialAndUnitText" style="width: 75px;"> {{element.Model}} </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CreateDate_">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header > {{'Date' | translate | async}} </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.CreateDate_ | date : 'dd-MMM-yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="SMR">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'SMR' | translate | async}} </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.SMR}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="SMRDiff">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'SMR Difference' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element">
                        <span >
                            <div class="{{getEvalClass(element.SMRDiff)}}"  style="width:25px"> {{element.SMRDiff}}</div>
                        </span> 
                        
                        </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Inspector">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Inspector' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Inspector}}">
                        <div class="SerialAndUnitText"> {{element.Inspector}} </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Status' | translate | async}}
                    </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.Status}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="flag">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Flag' | translate | async}}</mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element">
                        <div style="display: flex;">

                     

                            <div class="menutoggle" *ngIf="element.hasAttentionRequired==true">
                                <i *ngIf="element.hasAttentionRequired==true" class="material-icons button__icon"
                                    style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu;"
                                    [style.color]="GetColor(1)" title="{{'Fail - Attention Required' | translate | async}}">flag</i>
                                <span class="badge">{{element.AttentionRequiredCount}}</span>
                            </div>
                            <div class="menutoggle" *ngIf="element.hasImmediateAction==true">
                                <i *ngIf="element.hasImmediateAction==true" class="material-icons button__icon"
                                    style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu;"
                                    [style.color]="GetColor(2)"
                                    title="{{'False/Unable to Answer - Immediate Action required' | translate | async}}">flag</i>

                                <span class="badge">{{element.ImmediateActionCount}}</span>
                            </div>
                            <div class="menutoggle" *ngIf="element.hasMultipleAnswers==true">
                                <i *ngIf="element.hasMultipleAnswers==true" class="material-icons button__icon"
                                    style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu;"
                                    [style.color]="GetColor(3)" title="{{'Multiple Answers' | translate | async}}">flag</i>
                                <span class="badge">{{element.MultipleAnswersCount}}</span>
                            </div>
                            <div class="menutoggle" *ngIf="element.hasCommentAdded==true">
                                <i *ngIf="element.hasCommentAdded==true" class="material-icons button__icon"
                                    style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu;"
                                    [style.color]="GetColor(4)" title="{{'Comment Added' | translate | async}}">flag</i>
                                <span class="badge">{{element.CommentAddedCount}}</span>
                            </div>

                        </div>


                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" *ngIf="isSupervisour==true">
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Delete' | translate | async}}</mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" (click)="$event.stopPropagation()">
                        <i class="material-icons button__icon"
                            (click)="OpenDeleteInspection(element.FormId, element.UploadId)"
                            style="cursor: pointer;    color: #5D7FF9;"> delete</i>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description" >
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Report Options' | translate | async}}</mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" (click)="$event.stopPropagation()">
                        
                            <div  [matMenuTriggerFor]="inspectionMenu" >
                                <i class="material-icons button__icon"                        
                                    style="cursor: pointer;    color: #5D7FF9;"> description</i>
                                    <mat-menu #inspectionMenu="matMenu">
                                        <button  mat-menu-item (click)="openLink(element.FormId, element.UploadId)">{{'Report Option' | translate | async}}</button>
                                        <button mat-menu-item (click)="GetPdfDigitalForm( element.UploadId)">{{'Generate PDF' | translate | async}}</button>                            
                                    </mat-menu>  
                             </div> 
                    </mat-cell>
                </ng-container>
                

                <!-- <ng-container matColumnDef="pdf" >
                    <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Report Options </mat-header-cell>
                    <mat-cell class="customWidthClass" *matCellDef="let element" (click)="$event.stopPropagation()">
                        <div  [matMenuTriggerFor]="inspectionMenu" >
                        <i class="material-icons button__icon"
                            (click)="OpenDeleteInspection(element.FormId, element.UploadId)"
                            style="cursor: pointer;    color: #5D7FF9;"> pdf</i>
                            <mat-menu #inspectionMenu="matMenu">
                                <button  mat-menu-item (click)="openLink(element.FormId, element.UploadId)">{{'Report Option'}}</button>
                                <button mat-menu-item >{{'Generate PDF'}}</button>                            
                            </mat-menu>
                     </div>
                    </mat-cell>
                </ng-container> -->

                

                <mat-header-row *matHeaderRowDef="displayedColumns; "></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns; "  (click)="navigatetoUploadForm(row)" style="cursor: pointer;"></mat-row>
            </mat-table>

            <mat-paginator [length]="recordCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                     (page)="onUserPaginateChange($event)">
            </mat-paginator>

        </div>
    </mat-tab>
    <mat-tab label="{{'Available Forms' | translate | async}}" *ngIf="isSupervisour==true || isInspector==true || isJobRoleDefault==false ">
        <div style="margin-left: 39%;" *ngIf="Availableloading">
            <mat-spinner> </mat-spinner>
        </div>


        <div *ngIf="AvailbleFilteredDigitalForms != null && !Availableloading">


            <table class="table table--full-width table--striped table--hover">
                <thead>
                    <tr>
                        <th>{{'Form Name' | translate | async}}</th>
                        <th>{{'Form Category' | translate | async}}</th>
                        <th>{{'Linked Models' | translate | async}}</th>
                        <th>{{'Linked Customers' | translate | async}}</th>
                        <th>{{'Start New' | translate | async}}</th>
                        <!-- <th  *ngIf="isAdmin==true">Edit</th>
                    <th  *ngIf="isAdmin==true">Copy</th> -->
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let forms of AvailbleFilteredDigitalForms">
                        <tr>
                            <td class=" columncell" title="{{forms.FormName}}">{{forms.FormName}}</td>
                            <td class=" columncell" title="{{forms.CatName}}">{{forms.CatName}}</td>
                            <td class="columncell CelltextWrap" title="{{forms.ModelsList}}">{{forms.ModelsList}}</td>
                            <td class="columncell CelltextWrap" title="{{forms.CustomerList}}">{{forms.CustomerList}}
                            </td>
                            <td class="columncell">
                                <a *ngIf="isSupervisour" (click)="FillNewForm(forms.FormId, forms.IsStartBySupervisor)">
                                    <i class="material-icons button__icon">description</i>
                                </a>
                                <a *ngIf=" !isSupervisour && isInspector && forms.IsStartByInspector"
                                    (click)="FillNewForm(forms.FormId,  forms.IsStartByInspector)">
                                    <i class="material-icons button__icon">description</i>
                                </a>

                                <a
                                    *ngIf=" !isSupervisour  && !forms.IsStartByInspector && (isInspector || !isJobRoleDefault)">
                                    <i class="material-icons button__icon"
                                        title="You must have supervisor access to start this form.">lock</i>
                                </a>

                                <a *ngIf=" !isSupervisour && !isInspector && forms.IsStartByInspector">
                                    <i class="material-icons button__icon"
                                        title="You must have Inspector access to start this form.">lock</i>
                                </a>
                            </td>

                            <!-- <td class="columncell"  *ngIf="isAdmin">
                          <a (click)="redirectToEdit(forms.FormId)">
                            <i class="material-icons button__icon">create</i>
                           </a>
                        </td>
                        <td class="columncell"  *ngIf="isAdmin" > 
                          <a (click)="OpenCopyFormDialog(forms.FormId)" >
                          <i class="material-icons button__icon">content_copy</i>
                         </a></td> -->

                        </tr>
                    </ng-container>

                </tbody>
            </table>
             <mat-paginator [length]="recordCount1" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                     (page)="onUserPaginateChange($event)">
            </mat-paginator>
        </div>
    </mat-tab>
</mat-tab-group>
